export default {
  "goals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["eesmärki"])},
  "last_week_completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eelmine nädal täidetud"])},
  "toggle_dark_theme": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tume teema"])},
  "happy_new_year": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Head uut aastat!"])},
  "so_far_done": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siiani täidetud"])},
  "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nädal"])},
  "weekly_goals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nädala eesmärgid"])}
}